class ThankYou {
  private view: HTMLElement | null;

  bindings() {
    if (this.view) {
      setTimeout(() => {
        this.view?.classList.add('is-finished');
      }, 5000);
    }
  }

  cache() {
    this.view = document.querySelector('.js-thank-you');
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default ThankYou;
